__turbopack_context__.v({
  "card": "styles-module__6sIDQW__card",
  "cardContent": "styles-module__6sIDQW__cardContent",
  "cardImage": "styles-module__6sIDQW__cardImage",
  "cardReverse": "styles-module__6sIDQW__cardReverse",
  "displayImage": "styles-module__6sIDQW__displayImage",
  "featuresSection": "styles-module__6sIDQW__featuresSection",
  "section": "styles-module__6sIDQW__section",
});
